import MultiSelect from "@components/multiSelect/multiSelect";
import memberDetailsService from "@services/memberDetails.service";
import { useEffect, useState } from "react";

const SingleSelectWithDynamicOptions = ({ optionsKey, handleRulesOnValueChange, placeholder, value, className }: any) => {
  const [fieldValue, setFieldValue] = useState(value);

  const [options, setOptions] = useState([]);

  const onChange = (value: any) => {
    setFieldValue(value);
    handleRulesOnValueChange(value);
  };

  useEffect(() => {
     setFieldValue(value);
   }, [value]);

  useEffect(() => {
    memberDetailsService.fetchCaseStatusActiveDropdown(optionsKey).subscribe({
      next: (response: any) => {
        setOptions(response.data.data.data);
        console.log(response.data.data.data);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }, []);

  return (
    //   {/* ********************* For Single select use this code *************************  */}
    //   {/* <Select placeholder={placeholder} value={fieldValue} style={{ width: "30%" }} onChange={(value) => onChange(value)}>
    //     {options.map((opt: any) => {
    //       return <Select.Option key={opt.key}>{opt.value}</Select.Option>;
    //     })}
    //       </Select> */}

    <MultiSelect className={className} handleSelect={(value) => onChange(value)} value={fieldValue} options={options} />
  );
};

export default SingleSelectWithDynamicOptions;
